export const SELECT_DATA_TME_PERIOD = "@@ddw.herdnet.sandbox.hnadvice/SELECT_DATA_TME_PERIOD";
export const SELECT_LACTATION_FILTERS = "@@ddw.herdnet.sandbox.hnadvice/SELECT_LACTATION_FILTERS";
export const SELECT_DATA_TME_START = "@@ddw.herdnet.sandbox.hnadvice/SELECT_DATA_TME_START";
